import { Servicos } from "pages/Auth/Servicos";
import { ValidadorDocumentos } from "pages/Auth/Servicos/ValidadorDocumentos";
import { ServicosDisponiveis } from "pages/Servicos";
import {
  Route,
  BrowserRouter as Router,
  Routes as RoutesList
} from "react-router-dom";
import { LayoutDefault } from "../../layouts/LayoutDefault";
import { LayoutBody } from "../../layouts/LayoutDefault/Body";
import { AcessoNegado } from "../../pages/Auth/AcessoNegado";
import { CallbackPage } from "../../pages/Auth/CallbackPage";
import { Login } from "../../pages/Auth/Login";
import { Home } from "../../pages/Home";
import { Auth } from "./base/Auth";
import { Protected } from "./base/Protected";
import { ConsultaPreviaRoutes } from "./modules/ConsultaPreviaRoutes";
import { LicenciamentoUrbanoRoutes } from "./modules/LicenciamentoUrbanoRoutes";
import { MapaRoutes } from "./modules/MapaRoutes";
import { ClarityIdentify } from "../clarity";
import { OuvidoriaRoutes } from "./modules/OuvidoriaRoutes";
import { ZoonoseRoutes } from "./modules/ZoonoseRoutes";

export const Routes = () => {
  return (
    <Router>
      <ClarityIdentify />
      <RoutesList>
        <Route element={<Auth />}>
          <Route path="/" element={<LayoutDefault />}>
            <Route element={<LayoutBody />}>
              <Route element={<Protected />}>
                <Route index element={<Home />} />
                <Route
                  path="/servicos-disponiveis"
                  element={<ServicosDisponiveis />}
                />
                <Route path="/mapa/*" element={<MapaRoutes />} />
                <Route path="/zoonose/*" element={<ZoonoseRoutes />} />
                <Route
                  path="/licenciamento-urbano/*"
                  element={<LicenciamentoUrbanoRoutes />}
                />
                <Route
                  path="/consulta-previa/*"
                  element={<ConsultaPreviaRoutes />}
                />
                <Route path="/ouvidoria/*" element={<OuvidoriaRoutes />} />
              </Route>
            </Route>
          </Route>
        </Route>

        <Route path="login" element={<Login />} />
        <Route path="servicos" element={<Servicos />} />
        <Route path="servicos/validador" element={<ValidadorDocumentos />} />
        <Route path="auth/callback" element={<CallbackPage />} />
        <Route path="acessonegado" element={<AcessoNegado />} />
      </RoutesList>
    </Router>
  );
};
